export const isLoadingUpdateReportValueSelector = ({ scenarios }) =>
  scenarios.report.isLoadingUpdateReportValue;

export const isLoadingResettingReportValueSelector = ({ scenarios }) =>
  scenarios.report.isLoadingResetReportValue;
